export const Marquee = ({ items }) => {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-[#4D6354]/12 bg-[#EFECE6] py-5" data-testid="marquee">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center whitespace-nowrap font-display text-xl italic text-[#4D6354] sm:text-2xl"
              >
                <span className="px-6">{item}</span>
                <span className="text-[#C49A5A]">·</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
